import { Box, ListItemAvatar, Typography } from '@mui/material';
import { ReactNode } from 'react';

import { tPortalLib } from '../../locales';
import { ListItemCard } from '../list-item-card.component';

export interface MenuItemCardProps {
  displayName: string;
  ariaLabel: string;
  description?: string;
  thumbnail?: ReactNode | undefined;
  kcal?: number;
  price?: string;
  tags?: string[];
  onClick?: () => void;
}

export const MenuItemCard = (props: MenuItemCardProps) => {
  const subtitle =
    [
      props.price,
      props.kcal
        ? tPortalLib.general.kcal({ kcal: props.kcal.toString() })
        : undefined,
    ]
      .filter(Boolean)
      .join(' - ') || undefined;

  return (
    <ListItemCard
      primaryText={
        <Typography variant="subtitle1">{props.displayName}</Typography>
      }
      secondaryText={subtitle || props.description}
      tertiaryText={subtitle ? props.description : undefined}
      onClick={props.onClick}
      endAdornment={
        props.thumbnail && (
          <Box sx={{ marginBottom: 'auto' }}>
            <ListItemAvatar>
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: '4px',
                  overflow: 'hidden',
                }}
              >
                {props.thumbnail}
              </Box>
            </ListItemAvatar>
          </Box>
        )
      }
      ariaLabel={props.ariaLabel}
      tags={props.tags}
    />
  );
};
